import styled from "styled-components"

export const Wrapper = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    padding: 20px auto 0;
    grid-template-rows: auto auto auto;
    
    ${({ theme }) => theme.mq.atTablet`
        grid-template-rows: auto auto auto;
    `} 

    header {
        grid-column: 2 / 12;
        background: rgba(255,255,255,0.4);
        min-height: 10vh;
    }

    & #background-image {
        grid-column: 1 / 12;
        height: 80vh;
        overflow: hidden;
    }


    main {
        grid-column: 2 / 12 ;
        min-height: 60vh;

        ${({ theme }) => theme.mq.atTablet`
         grid-column: 4 / 9 ;

        `}

        h1 {
            margin-top: 80px;
            ${({ theme }) => theme.text.large}
            font-size: 2.2rem !important;
            color: var(--blue);
        }

        p {
            ${({ theme }) => theme.text.small}
            font-size: 1.25rem !important;;
            color: var(--black);

        }

    }

    footer {
        grid-column: 1 / -1;
        min-height: 100px;
        background-color: var(--offWhite);

    }

`

export const HeaderWrapper = styled.div`
    display: flex;
    width: 100%;
    align-items: center;


    & > a {
        margin-left: auto;
    }
`

export const ButtonPositioner = styled.div`
    position: absolute;
    right: 8vw;
    bottom: 5vh;

    height: 60px;
    width: 60px;
`